import { render, staticRenderFns } from "./CurrentRights.vue?vue&type=template&id=00440c68&scoped=true"
import script from "./CurrentRights.vue?vue&type=script&lang=js"
export * from "./CurrentRights.vue?vue&type=script&lang=js"
import style0 from "./CurrentRights.vue?vue&type=style&index=0&id=00440c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00440c68",
  null
  
)

export default component.exports